import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchFaqs } from "../services/api";

export const getFaqs = createAsyncThunk("faqs/fetchFaqs", async () => {
    const response = await fetchFaqs();
    return response;
});

const faqsSlice = createSlice({
    name: "faqs",
    initialState: { data: [], status: "idle" },
    extraReducers: (builder) => {
        builder
            .addCase(getFaqs.pending, (state) => {
                state.status = "loading";
            })
            .addCase(getFaqs.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.data = action.payload;
            })
            .addCase(getFaqs.rejected, (state) => {
                state.status = "failed";
            });
    },
});

export default faqsSlice.reducer;
